// บันทึกภาษีหัก ณ ที่จ่าย บันทึกค่าใช้จ่ายอื่นๆ
import React, { useEffect, useState, useRef, createRef } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import axios from 'axios'
import { gengetURLTEST, genURL } from "./../../../_getjson";
import { DropdownButton, MenuItem, Row, Grid, Col, Panel } from "react-bootstrap";
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import PopupApcode from './../../../PopUp/PopUpApcode'
import ChackAp from './../../../CustomFunction/Csap/GetAp'

import SelectFix from './../../../PopUp/SelectFix';
import PopUpOther from "./../../../PopUp/PopUpOther";
import Snackbar from './../../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
export default function Withholding(props) {

    const { parm, recheckeddata, from } = props
    const [listitem, setListitem] = useState([])
    const [SwitchPopupApcode, setSwitchPopupApcode] = useState()
    const [OtPopupType, setOtPopupType] = useState()
    const [SwitchOtherPopup, setSwitchOtherPopup] = useState()
    const [Docgrouptxt, setDocgrouptxt] = useState("")
    const [Apcode, setApcode] = useState("")
    const [Incometypetxt, setIncometypetxt] = useState("")
    const [taxtypetxt, settaxtypetxt] = useState("")
    const [Rungroup, setRungroup] = useState("")
    const [selectrow, setselectrow] = useState(false)
    const [rowid, setrowid] = useState("")

    const [color, setColor] = useState("warning");
    const [icon, setIcon] = useState(ErrorIcon);
    const [messagealert, setMessagealert] = useState("");
    const [autoClose, setautoClose] = useState(3600);
    const [opensnackbar, setopensnackbar] = useState(false);

    const Deliverydate = useRef(null);
    const Docgroupcode = useRef(null);
    const Docgroup = useRef(null);
    const Notax = useRef(null);
    const Totaltax = useRef(null);
    const Payablecode = useRef(null);
    const Payablename = useRef();
    const taxtypecode = useRef(null);
    const taxtype = useRef(null);
    const Incometypecode = useRef(null);
    const Incometype = useRef(null);
    const Deductionconditions = useRef(null);
    const Remark = useRef(null);
    const Taxrate = useRef(null);
    const Amountbeforetax = useRef(null);
    const Withholdingtax = useRef(null);
    const Actingonbehalf = useRef(null);

    useEffect(() => {

        componentdidmount(true, true, true)
    }, [])
    useEffect(() => {
        if (recheckeddata.length > 0) {
            setrecheckdata()
        }
    }, [recheckeddata])

    const setrecheckdata = async () => {

        let url = `CSAPWTAX/Search?Tablename=` + from + `&Docno=` + recheckeddata[0].DOCNO
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            //   console.log(" componentdidmount  res.length", res.data)
            let item = []
            let Newitem = []
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    let Taxincludeddata = res.data[i].TAXRATE
                    //    Number(res.data[i].BEFORETAX)
                    item[i] = {
                        Taxinvoice: res.data[i].TAXNO,
                        Incometypecode: res.data[i].INCOMETYPE,
                        PayableCode: res.data[i].APCODE,
                        PayableName: res.data[i].APNAME,
                        Taxdescription: res.data[i].REMARK,
                        Amountbeforetax: res.data[i].BEFORETAX,
                        Tax: res.data[i].TAXRATE,
                        Taxincluded: res.data[i].TOTALAMOUNT
                    }
                }
            }
            setListitem(item)
        })
    }
    const componentdidmount = async (setteble, settext, ttt) => {
        setselectrow(false)
        console.log(parm);

        if (parm.defulttable.length > 0 && ttt === true) {
            setListitem([...parm.defulttable])
            await Submit(true)
        } else {
            if (setteble === true) {
                let item = []
                for (let index = 0; index < 30; index++) {
                    item[index] = {
                        numrow: index + 1,
                        Taxinvoice: "",
                        Incometypecode: "",
                        PayableCode: "",
                        PayableName: '',
                        Taxdescription: "",
                        Amountbeforetax: "",
                        Tax: "",
                        Taxincluded: ""
                    }
                    await setListitem(item)
                }
                await Submit(true)
            }
        }


        if (settext === true) {
            if (parm.Deliverydate !== "") {
                Deliverydate.current.value = parm.Deliverydate
            }
            setTimeout(() => {
                onAddValue("Groupdata", "WT001", "1");
            }, 100);
            Notax.current.value = parm.Notax
            Payablecode.current.value = parm.Payablecode
            Payablename.current.value = parm.Payablename
            taxtypecode.current.value = parm.taxtypecode
            taxtype.current.value = parm.taxtype
            settaxtypetxt(parm.taxtype)
            Incometypecode.current.value = parm.Incometypecode
            Incometype.current.value = parm.Incometype
            setIncometypetxt(parm.Incometype)
            Remark.current.value = parm.Remark
            if (parm.Deductionconditions) {
                Deductionconditions.current.value = parm.Deductionconditions
            } else {
                Deductionconditions.current.value = "1"
            }
            if (parm.Taxrate) {
                Taxrate.current.value = parm.Taxrate
            } else {
                Taxrate.current.value = "0.00"
            }
            if (parm.Totaltax) {
                Totaltax.current.value = parm.Totaltax
            } else {
                Totaltax.current.value = "0.00"
            }
            if (parm.Amountbeforetax) {
                Amountbeforetax.current.value = parm.Amountbeforetax
            } else {
                Amountbeforetax.current.value = "0.00"
            }
            if (parm.Withholdingtax) {
                var sum = Number(parm.Amountbeforetax / 100 * Taxrate.current.value)
                Withholdingtax.current.value = parseFloat(sum).toFixed(2)
                // Withholdingtax.current.value = parm.Withholdingtax
            } else {
                Withholdingtax.current.value = "0.00"
            }
            Actingonbehalf.current.value = parm.Actingonbehalf
        }
        // Deductionconditions.current.value)
        // Taxrate.current.value)
        // Amountbeforetax.current.value)
        // Withholdingtax.current.value)
        // Actingonbehalf.current.value)
        // Totaltax.current.value)

    }

    const Auto = async () => {
        var CODE = "", MYNAMETH = "", WTAXRATE = "0.00"
        var url = "CSINCOMETYPE/Search?Code="
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then((res) => {

            console.log("CSINCOMETYPE", res.data);
            if (res.data.length > 0) {
                CODE = res.data[0].CODE
                MYNAMETH = res.data[0].MYNAMETH
                WTAXRATE = res.data[0].WTAXRATE
            }
        }).catch((err) => {
            console.log(err);
        });
        setselectrow(false)
        var table = listitem
        var sum = ""
        var result = ""
        let Date = Deliverydate.current.value.split('/')
        if (Rungroup) {
            sum = Rungroup + '-TT' + Date[1] + '-'
        }
        var url = "CSAPWTAXRUN/Search?Code=" + sum
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then((res) => {

            if (res.data !== undefined) {
                result = res.data
            }
        }).catch((err) => {
            console.log(err);
        }).finally(_ => {
            // console.log(CODE);
            for (let i = 0; i < table.length; i++) {
                var sum = Number(table[0].Amountbeforetax / 100 * 5)
                if (table[i].Taxinvoice) {
                    table[i] = {
                        numrow: 1,
                        Taxinvoice: result,
                        Incometypecode: CODE,
                        Datetime: table[i].Datetime,
                        PayableCode: table[i].PayableCode,
                        PayableName: table[i].PayableName,
                        Remark: "",
                        Deduction: table[i].Deduction,
                        Taxrate: WTAXRATE,
                        Amountbeforetax: table[i].Amountbeforetax,
                        Tax: parseFloat(sum).toFixed(2),
                        Taxtype: table[i].Taxtype,
                        Taxtypetxt: table[i].Taxtypetxt,
                        Actingonbehalf: table[i].Actingonbehalf,
                    }
                }
                if (i > 0) {
                    table[i] = {
                        numrow: i + 1,
                        Taxinvoice: "",
                        Incometypecode: "",
                        Datetime: "",
                        PayableCode: "",
                        PayableName: "",
                        Remark: "",
                        Deduction: "",
                        Taxrate: "",
                        Amountbeforetax: "",
                        Tax: "",
                        Taxtype: "",
                        Taxtypetxt: "",
                        Actingonbehalf: "",
                    }
                }
            }
            console.log(table);
            setListitem([...table])
        })

    }

    const SelectSetData = (type, data) => {
        switch (type) {
            case "Calendar1":
                Deliverydate.current.value = data
                Submit(true)
                break;
            default:
                break;
        }
    }

    const setRungrouptax = async () => {
        var sum = ""
        var result = ""
        let Deliverydate1 = Deliverydate.current.value
        let Date = Deliverydate1.split('/')
        if (Rungroup) {
            sum = Rungroup + '-TT' + Date[1] + '-'
        }
        var url = "CSAPWTAXRUN/Search?Code=" + sum
        // console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
            if (res.data !== undefined) {

                if (Docgroup.current.value) {
                    console.log("resultelse if", res.data);
                    Notax.current.value = res.data
                } else {
                    Notax.current.value = ""
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }
    const Switch_PopupApcode = (e) => {
        setApcode(e)
        setSwitchPopupApcode(!SwitchPopupApcode)
    }
    const Get_PopupApcode = (data1, data2) => {
        switch (Apcode) {
            case 'Payablecode':
                Payablecode.current.value = data1
                Payablename.current.value = data2
                break;
            case 'Actingonbehalf':
                Actingonbehalf.current.value = data1
                break;
            default:
                break;
        }
    }
    const Switch_OtherPopup = (type) => {
        setOtPopupType(type)
        setSwitchOtherPopup(!SwitchOtherPopup)
    };
    const Get_PopUpOther = async (result) => {
        console.log(result);
        var data = result.split("|");
        switch (OtPopupType) {
            case 'Groupdataall':
                Docgroupcode.current.value = data[0]
                Docgroup.current.value = data[1]
                await setDocgrouptxt(data[1]);
                await setRungroup(data[2]);
                await setRungrouptax()

                break;
            case 'Incometype':
                Incometypecode.current.value = data[0]
                Incometype.current.value = data[1]
                Taxrate.current.value = data[2]
                setIncometypetxt(data[1]);
                break;
            case 'taxtype':
                taxtypecode.current.value = data[0]
                taxtype.current.value = data[1]
                settaxtypetxt(data[1]);
                break;
            default:
                break;
        }
    }
    const Addtable = () => {
        if (Docgroup.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกกลุ่มข้อมูล")
            return
        }
        if (Payablecode.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกรหัสเจ้าหนี้")
            return
        }
        if (taxtype.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกประเภท")
            return
        }
        if (Incometype.current.value === "") {
            setopensnackbar(true)
            setColor("warning")
            setIcon(ErrorIcon)
            setMessagealert("กรุณาเลือกประเภทเงินได้")
            return
        }
        var data = listitem
        for (var i = 0; i < data.length && data[i].Taxinvoice; i++) {
            if (data[i].Taxinvoice !== Notax.current.value) {
                setopensnackbar(true)
                setColor("warning")
                setIcon(ErrorIcon)
                setMessagealert("เลขที่จะต้องตรงกันเท่านั้น")
                return
            }
        }
        if (selectrow === true) {
            i = rowid
        }
        data[i] = {
            numrow: i + 1,
            Taxinvoice: Notax.current.value,
            Incometypecode: Incometypecode.current.value,
            Incometypetxt: Incometypetxt,
            Datetime: Deliverydate.current.value,
            PayableCode: Payablecode.current.value,
            PayableName: Payablename.current.value,
            Remark: Remark.current.value,
            Deduction: Deductionconditions.current.value,
            Taxrate: Taxrate.current.value,
            Amountbeforetax: Amountbeforetax.current.value,
            Tax: Withholdingtax.current.value,
            Taxtype: taxtypecode.current.value,
            Taxtypetxt: taxtypetxt,
            Actingonbehalf: Actingonbehalf.current.value,
        }
        setListitem([...data])
        var sss = 0.00
        for (let j = 0; j < listitem.length && listitem[j].Taxinvoice; j++) {
            sss += Number(listitem[j].Taxrate)
            console.log(sss);
        }
        Totaltax.current.value = sss.toFixed(2)
        setRungrouptax()
        setTimeout(() => {
            Incometypecode.current.value = ""
            Incometype.current.value = ""
            setIncometypetxt("")
            taxtypecode.current.value = ""
            taxtype.current.value = ""
            settaxtypetxt("")
            Payablecode.current.value = parm.Payablecode
            Payablename.current.value = parm.Payablename
            Taxrate.current.value = "0.00"
            Deductionconditions.current.value = "1"
            Amountbeforetax.current.value = "0.00"
            Withholdingtax.current.value = "0.00"
        }, 200);
    }
    const onAddValue = (type, value, Y) => {
        console.log(type, value);
        if (value) {
            switch (type) {
                case "Groupdata":
                    var url = "CSDOCGROUP/Searchbycode?tablename=CSAPWTAX_RUN&code=" + value + "&Usercode=" + sessionStorage.getItem("Username") + "&top=300"
                    console.log(genURL(url));
                    axios.get(genURL(url), { timeout: 3600 }).then(async (res) => {
                        console.log(res.data.length);
                        if (res.data.length === 1) {
                            if (document.getElementById('Docgroupcode') != null) {
                                Docgroupcode.current.value = res.data[0].CODE
                                Docgroup.current.value = res.data[0].MYNAMETH
                                setDocgrouptxt(res.data[0].MYNAMETH)
                                await setRungroup(res.data[0].RUNGROUP);
                                if (Y !== "1") {
                                    setRungrouptax()
                                }
                            }
                        }
                        else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบกลุ่มข้อมูล")
                            if (document.getElementById('Docgroupcode') != null) {
                                document.getElementById("Docgroupcode").value = ""
                                document.getElementById("Docgroup").value = ""
                                setDocgrouptxt("")
                                setRungroup("");
                            }
                        }
                    }).catch((err) => {
                        if (document.getElementById('Docgroupcode') != null) {
                            document.getElementById("Docgroupcode").value = ""
                            document.getElementById("Docgroup").value = ""
                            setDocgrouptxt("")
                            setRungroup("");
                        }
                        console.log(err);
                    });
                    break;
                case "Incometype":
                    var url = "CSINCOMETYPE/Search?Code=" + value
                    console.log(genURL(url));
                    axios.get(genURL(url), { timeout: 3600 }).then((res) => {
                        console.log(res.data.length);
                        if (res.data.length === 1) {
                            Incometypecode.current.value = res.data[0].CODE
                            Incometype.current.value = res.data[0].MYNAMETH
                            Taxrate.current.value = res.data[0].WTAXRATE
                            setIncometypetxt(res.data[0].MYNAMETH);
                        }
                        else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูลประเภทเงินได้")
                            if (document.getElementById('Incometypecode') != null) {
                                document.getElementById("Incometypecode").value = ""
                                document.getElementById("Incometype").value = ""
                                Taxrate.current.value = "0.00"
                                setIncometypetxt("")
                            }
                        }
                    }).catch((err) => {
                        if (document.getElementById('Incometypecode') != null) {
                            document.getElementById("Incometypecode").value = ""
                            document.getElementById("Incometype").value = ""
                            Taxrate.current.value = "0.00"
                            setIncometypetxt("")
                        }
                        console.log(err);
                    });
                    break;
                case "taxtype":
                    var url = "CSWTAXTYPE/Search?Code=" + value
                    console.log(genURL(url));
                    axios.get(genURL(url), { timeout: 3600 }).then((res) => {
                        console.log(res.data.length);
                        if (res.data.length === 1) {
                            taxtypecode.current.value = value
                            taxtype.current.value = res.data[0].MYNAMETH
                            settaxtypetxt(res.data[0].MYNAMETH);
                        }
                        else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            if (document.getElementById('taxtypecode') != null) {
                                document.getElementById("taxtypecode").value = ""
                                document.getElementById("taxtype").value = ""
                                settaxtypetxt("")
                            }
                        }
                    }).catch((err) => {
                        if (document.getElementById('taxtypecode') != null) {
                            document.getElementById("taxtypecode").value = ""
                            document.getElementById("taxtype").value = ""
                            settaxtypetxt("")
                        }
                        console.log(err);
                    });
                    break;
                case "Payablecode":
                    ChackAp(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            Payablecode.current.value = value
                            Payablename.current.value = data[0]
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            if (document.getElementById('Payablecode') != null) {
                                document.getElementById("Payablecode").value = ""
                                document.getElementById("Payablename").value = ""
                            }
                        }
                    }).catch((err) => {
                        if (document.getElementById('Payablecode') != null) {
                            document.getElementById("Payablecode").value = ""
                            document.getElementById("Payablename").value = ""
                        }
                        console.log(err);
                    });
                    break;
                case "Actingonbehalf":
                    ChackAp(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            Actingonbehalf.current.value = data[1]
                        } else {
                            setopensnackbar(true)
                            setColor("warning")
                            setIcon(ErrorIcon)
                            setMessagealert("ไม่พบข้อมูล")
                            Actingonbehalf.current.value = ""
                        }
                    }).catch((err) => {
                        Actingonbehalf.current.value = ""
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    };

    const Submit = (e) => {
        // if (e === true) {
        let resdata = []
        resdata.push(e)
        resdata.push(listitem)
        console.log(document.getElementById("Deliverydate").value);
        let Deliverydate = document.getElementById("Deliverydate").value;
        resdata.push(Deliverydate)
        let Docgroupcode = document.getElementById("Docgroupcode").value;
        resdata.push(Docgroupcode)
        let Notax = document.getElementById("Notax").value;
        resdata.push(Notax)
        let Payablecode = document.getElementById("Payablecode").value;
        resdata.push(Payablecode)
        let Payablename = document.getElementById("Payablename").value;
        resdata.push(Payablename)
        let taxtypecode = document.getElementById("taxtypecode").value;
        resdata.push(taxtypecode)
        let taxtype = document.getElementById("taxtype").value;
        resdata.push(taxtype)
        let Incometypecode = document.getElementById("Incometypecode").value;
        resdata.push(Incometypecode)
        let Incometype = document.getElementById("Incometype").value;
        resdata.push(Incometype)
        let Remark = document.getElementById("Remark").value;
        resdata.push(Remark)
        let Deductionconditions = document.getElementById("Deductionconditions").value;
        resdata.push(Deductionconditions)
        let Taxrate = document.getElementById("Taxrate").value;
        resdata.push(Taxrate)
        let Amountbeforetax = document.getElementById("Amountbeforetax").value;
        resdata.push(Amountbeforetax)
        let Withholdingtax = document.getElementById("Withholdingtax").value;
        resdata.push(Withholdingtax)
        let Actingonbehalf = document.getElementById("Actingonbehalf").value;
        resdata.push(Actingonbehalf)
        let Totaltax = document.getElementById("Totaltax").value;
        resdata.push(Totaltax)
        props.resdata(resdata)
        // }
    }
    const SetRowNull = () => {
        setselectrow(false)
        if (Notax.current.value) {
            var col = listitem
            var NewCol = [];
            var j = 0;
            for (var i = 0; i < col.length; i++) {
                if (col[i].Taxinvoice) {
                    if (col[i].Taxinvoice !== Notax.current.value) {
                        NewCol[j] = col[i];
                        NewCol[j].numrow = j + 1;
                        j++;
                    }
                }
            }
            for (var i = j; i < col.length; i++) {
                NewCol[j] = { numrow: j + 1 };
                j++;
            }
            setListitem(NewCol)
            setTimeout(() => {
                Submit(true)
            }, 200);
        }
    }
    const onClick = (e) => {
        switch (e.target.name) {
            case "Docgroup":
                Docgroup.current.value = Docgroupcode.current.value
                Docgroup.current.select()
                break;
            case 'Incometype':
                Incometype.current.value = Incometypecode.current.value
                Incometype.current.select()
                break;
            case "taxtype":
                taxtype.current.value = taxtypecode.current.value
                taxtype.current.select()
                break;
            case "Taxrate":
                Taxrate.current.value = Number(e.target.value)
                Taxrate.current.select()
                break;
            case "Amountbeforetax":
                Amountbeforetax.current.value = Number(e.target.value)
                Amountbeforetax.current.select()
                break;
            case "Withholdingtax":
                Withholdingtax.current.value = Number(e.target.value)
                Withholdingtax.current.select()
                break;
            case "Totaltax":
                Totaltax.current.value = Number(e.target.value)
                Totaltax.current.select()
                break;
            default:
                break;
        }
    }
    const onKeyPress = (e) => {

        if (e.key === 'Enter') {
            switch (e.target.name) {
                case "Deliverydate":
                    Docgroup.current.focus()
                    break;
                case "Docgroup":
                    onAddValue("Groupdata", e.target.value);
                    Notax.current.focus()
                    break;
                case "Notax":
                    Totaltax.current.focus()
                    break;
                case "Totaltax":
                    Payablecode.current.focus()
                    break;
                case "Payablecode":
                    onAddValue("Payablecode", e.target.value);
                    Payablename.current.focus()
                    break;
                case "Payablename":
                    taxtype.current.focus()
                    break;
                case "taxtype":
                    onAddValue("taxtype", e.target.value);
                    Incometype.current.focus()
                    break;
                case "Incometype":
                    onAddValue("Incometype", e.target.value);
                    Remark.current.focus()
                    break;
                case "Remark":
                    Deductionconditions.current.focus()
                    break;
                case "Deductionconditions":
                    Taxrate.current.focus()
                    break;
                case "Taxrate":
                    Amountbeforetax.current.focus()
                    break;
                case "Amountbeforetax":
                    var sum = Number(e.target.value / 100 * Taxrate.current.value)
                    Withholdingtax.current.value = parseFloat(sum).toFixed(2)
                    Withholdingtax.current.focus()
                    break;
                case "Withholdingtax":
                    Actingonbehalf.current.focus()
                    break;
                case "Actingonbehalf":
                    Addtable()
                    // onAddValue("Actingonbehalf", e.target.value);
                    // Incometype.current.focus()
                    break;
                default:
                    break;
            }
        }
    }
    const onChange = (e) => {
        console.log(e.target.name);
        switch (e.target.name) {
            case 'Docgroup':
                if (e.target.value === "") {
                    Docgroupcode.current.value = ""
                    Docgroup.current.value = ""
                    setDocgrouptxt("");
                    setRungroup("");
                }
                break;
            case 'Payablecode':
                if (e.target.value === "") {
                    Payablecode.current.value = ""
                    Payablename.current.value = ""
                }
                break;
            case 'Actingonbehalf':
                console.log("Actingonbehalf");
                if (e.target.value === "") {
                    Actingonbehalf.current.value = ""
                }
                break;
            case 'Incometype':
                console.log("Incometype");
                if (e.target.value === "") {
                    Incometypecode.current.value = ""
                    Incometype.current.value = ""
                    setIncometypetxt("");
                }
                break;
            case 'taxtype':
                if (e.target.value === "") {
                    taxtypecode.current.value = ""
                    taxtype.current.value = ""
                    settaxtypetxt("");
                }
                break;
            default:
                break;
        }
    }
    const onBlur = (e) => {
        switch (e.target.name) {
            case "Docgroup":
                Docgroup.current.value = Docgrouptxt
                break;
            case 'Incometype':
                Incometype.current.value = Incometypetxt
                break;
            case "taxtype":
                taxtype.current.value = taxtypetxt
                break;
            case "Taxrate":
                Taxrate.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Amountbeforetax":
                Amountbeforetax.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Withholdingtax":
                Withholdingtax.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            case "Totaltax":
                Totaltax.current.value = parseFloat(e.target.value).toFixed(2)
                break;
            default:
                break;
        }
        Submit(true)
    }
    const onSelectRow = (row, col, id) => {
        if (row.Taxinvoice) {
            setselectrow(true)
            setrowid(id)

            Deliverydate.current.value = row.Datetime
            Notax.current.value = row.Taxinvoice
            Totaltax.current.value = row.Taxrate
            Payablecode.current.value = row.PayableCode
            Payablename.current.value = row.PayableName
            taxtypecode.current.value = row.Taxtype
            taxtype.current.value = row.Taxtypetxt
            settaxtypetxt(row.Taxtypetxt)

            Actingonbehalf.current.value = row.Actingonbehalf

            Incometypecode.current.value = row.Incometypecode
            Incometype.current.value = row.Incometypetxt
            setIncometypetxt(row.Incometypetxt)

            Remark.current.value = row.Remark
            Deductionconditions.current.value = row.Deduction
            Taxrate.current.value = row.Taxrate
            Amountbeforetax.current.value = row.Amountbeforetax
            Withholdingtax.current.value = row.Tax
        }
    }

    return (
        <div onClick={onClick} onKeyPress={onKeyPress} onChange={onChange} onBlur={onBlur} >
            {SwitchPopupApcode ? <PopupApcode closePopup={Switch_PopupApcode} Get_PopupApcode={Get_PopupApcode} /> : null}
            {SwitchOtherPopup ? (<PopUpOther closePopup={Switch_OtherPopup} type={OtPopupType} Get_PopUpOther={Get_PopUpOther} from="CSAPWTAX_RUN" />) : null}
            <div className="form-inline" style={{ marginBottom: '-30px' }}>
                <div className="form-group mb-2">
                    <nav className="navbar TopApp ssss" >
                        <div className="flex-list">
                            <ul className="nav navbar-nav navbar-left">
                                <li><span type="button" className="btn-md" onClick={() => { Submit() }}>  <i className="fas fa-save"></i> ตกลง </span></li>
                                <span className="pipe"></span>
                                <li><span type="button" className=" btn-md" onClick={() => { Auto() }}><i className="fas fa-atom"></i> อัตโนมัติ </span></li>
                                <span className="pipe"></span>
                                <li><span type="button" className=" btn-md" onClick={() => { componentdidmount(false, true) }}><i className="fas fa-file"></i> รายการใหม่ </span></li>
                                <span className="pipe"></span>
                                <li>
                                    <span type="button" className=" btn-md" onClick={() => { componentdidmount(true, false) }}>
                                        <i className="fas fa-eraser"></i> ล้างทั้งหมด
                                    </span>
                                </li>
                                <span className="pipe"></span>
                                <li>
                                    <span type="button" className=" btn-md" onClick={() => { SetRowNull() }}>
                                        <i className="fas fa-trash-alt"></i>ลบรายการ
                                    </span>
                                </li>
                                <span className="pipe"></span>
                                <li><span type="button" className=" btn-md" ><i className="fas fa-hammer"></i> Running ใหม่ทั้งหมด</span></li>
                                <span className="pipe"></span>
                                {/* <li><span type="button" className=" btn-md" onClick={() => { this.props.resdata() }}><i className="fas fa-door-open"></i> ปิดหน้าจอ</span></li>
                                                <span className="pipe"></span> */}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
            <div className="panel-body divTable" align="left">
                <BootstrapTable
                    data={listitem}
                    options={{
                        onRowClick: onSelectRow,
                        noData: "...."
                    }}
                    height='468' hover condensed>
                    <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="30" dataField='numrow' isKey> </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Taxinvoice' editable={false} > เลขที่ </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Incometypecode' editable={false} > ประเภทเงินได้ </TableHeaderColumn>
                    <TableHeaderColumn rowSpan="2" dataField='Incometypetxt' editable={false} hidden> ประเภทเงินได้ </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Datetime' editable={false}> ลงวันที่ </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='PayableCode' editable={false} > รหัสลูกหนี้ </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="140" dataField='PayableName' editable={false} > ชื่อผู้ขาย / ผู้ให้บริการ </TableHeaderColumn >
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="140" dataField='Remark' editable={false}>  หมายเหตุ </TableHeaderColumn>
                    <TableHeaderColumn rowSpan="2" dataField='Deduction' editable={false} hidden>  เงื่อนไขการหัก </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="80" dataField='Taxrate' editable={false}> อัตราภาษี </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Amountbeforetax' editable={false}> ยอดก่อนภาษี </TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Tax' editable={false}> ภาษี</TableHeaderColumn>
                    <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="left" width="80" dataField='Taxtype' editable={false}> ประเภท</TableHeaderColumn>
                    <TableHeaderColumn rowSpan="2" dataField='Taxtypetxt' editable={false} hidden> ประเภท</TableHeaderColumn>
                    <TableHeaderColumn rowSpan="2" dataField='Actingonbehalf' editable={false} hidden> กระทำการแทน</TableHeaderColumn>
                </BootstrapTable>

                <br />
                <Grid>

                    <Col xs={10} sm={12} md={10} lg={10}>
                        <Col xs={4} sm={12} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">วันที่นำส่ง </span>
                                                <input type="text" className="form-control" ref={Deliverydate} name="Deliverydate" id="Deliverydate" />
                                                <span className="input-group-addon icon">
                                                    <SelectFix type={"Calendar1"} SelectSetData={SelectSetData} />
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={4} sm={12} md={4} lg={4}>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">กลุ่มข้อมูล  </span>
                                                <input type="text" className="form-control hidden" ref={Docgroupcode} id="Docgroupcode" name="Docgroupcode" />
                                                <input type="text" className="form-control" ref={Docgroup} id="Docgroup" name="Docgroup" />
                                                <span id="Groupdataall" className="input-group-addon icon" onClick={Switch_OtherPopup.bind(null, "Groupdataall")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={4} sm={12} md={4} lg={4}>
                            <Row>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">เลขที่  </span>
                                                <input type="text" className="form-control" ref={Notax} name="Notax" id="Notax" disabled />
                                                <span id="iconTaxNumber" className="input-group-addon icon" onClick={setRungrouptax}>
                                                    <i className="fas fa-sync-alt" ></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row>
                                <Col xs={4} sm={12} md={4} lg={3}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 " >
                                                <span className="input-group-addon">รหัสเจ้าหนี้  </span>
                                                <input type="text" className="form-control" ref={Payablecode} name="Payablecode" id="Payablecode" />
                                                <span onClick={Switch_PopupApcode.bind(null, "Payablecode")} id="iconCustomerCode" className="input-group-addon icon">
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>

                                <Col xs={4} sm={12} md={4} lg={5}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 "   >
                                                <span className="input-group-addon">ชื่อเจ้าหนี้  </span>
                                                <input type="text" className="form-control" ref={Payablename} name="Payablename" id="Payablename" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>

                                <Col xs={4} sm={12} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">ประเภท  </span>
                                                <input type="text" className="form-control hidden" ref={taxtypecode} name="taxtypecode" id="taxtypecode" />
                                                <input type="text" className="form-control" ref={taxtype} name="taxtype" id="taxtype" />
                                                <span onClick={Switch_OtherPopup.bind(null, "taxtype")} className="input-group-addon icon">
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row>
                                <Col xs={3} sm={12} md={3} lg={3}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 " >
                                                <span className="input-group-addon">ประเภทเงินได้  </span>
                                                <input type="text" className="form-control hidden" ref={Incometypecode} name="Incometypecode" id="Incometypecode" />
                                                <input type="text" className="form-control" ref={Incometype} name="Incometype" id="Incometype" />
                                                <span onClick={Switch_OtherPopup.bind(null, "Incometype")} className="input-group-addon icon">
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={6} sm={12} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 "   >
                                                <span className="input-group-addon">หมายเหตุ  </span>
                                                <input type="text" className="form-control" ref={Remark} name="Remark" id="Remark" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={3} sm={12} md={3} lg={3}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">เงื่อนไขการหัก  </span>
                                                <input type="text" className="form-control" ref={Deductionconditions} name="Deductionconditions" id="Deductionconditions" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row>
                                <Col xs={3} sm={12} md={3} lg={3}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 " >
                                                <span className="input-group-addon">อัตราภาษี  </span>
                                                <input type="text" className="form-control Price" ref={Taxrate} name="Taxrate" id="Taxrate" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>

                                <Col xs={6} sm={12} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 "   >
                                                <span className="input-group-addon">ยอดก่อนภาษี  </span>
                                                <input type="text" className="form-control Price" ref={Amountbeforetax} name="Amountbeforetax" id="Amountbeforetax" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={3} sm={12} md={3} lg={3}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">ภาษีหัก ณ ที่จ่าย  </span>
                                                <input type="text" className="form-control Price" ref={Withholdingtax} name="Withholdingtax" id="Withholdingtax" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Col>

                    <Col xs={2} sm={12} md={2} lg={2}>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Row className="show-grid">
                                    <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                            <span className="input-group-addon">รวมยอดภาษี  </span>
                                            <input type="text" className="form-control Price" ref={Totaltax} name="Totaltax" id="Totaltax" />
                                        </div>
                                    </div>
                                </Row>
                                <Row className="show-grid">
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <Row className="show-grid">
                                            <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                    <span className="input-group-addon">กระทำการแทน </span>
                                                    <input type="text" className="form-control" ref={Actingonbehalf} name="Actingonbehalf" id="Actingonbehalf" />
                                                    <span onClick={Switch_PopupApcode.bind(null, "Actingonbehalf")} id="iconCustomerCode" className="input-group-addon icon">
                                                        <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Grid>
            </div>
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setopensnackbar(false) }}
                close />
        </div>
    )
}